export const Team = () => {
  return (
    <section>
      <ul>
        <li>
          <b>CEO</b> - Gabrijela Vohu Manah
        </li>
        <li>
          <b>Sales</b> - Darius Marianne
        </li>
        <li>
          <b>Product</b> - Ségdae Jean-Pierre
        </li>
        <li>
          <b>Marketing</b> - Melina Theotimos
        </li>
        <li>
          <b>Engineering</b> - Gregor Ramadhani
        </li>
      </ul>
    </section>
  );
};
